module.exports = __webpack_public_path__ + "img/letter-email.8066f8ad.jpg";